import { createIcon } from '@chakra-ui/icons';

export const Atom = createIcon({
  displayName: 'Atom',
  viewBox: '0 0 20 20',
  path: [
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_554_3125)">
        <path
          d="M16.7341 16.7346C18.5547 14.914 17.0155 10.423 13.2962 6.70365C9.57685 2.98433 5.08586 1.44512 3.26525 3.26573C1.44464 5.08633 2.98385 9.57733 6.70317 13.2966C10.4225 17.016 14.9135 18.5552 16.7341 16.7346Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2962 13.2967C17.0155 9.57734 18.5547 5.08635 16.7341 3.26574C14.9135 1.44513 10.4225 2.98434 6.70317 6.70366C2.98385 10.423 1.44464 14.914 3.26525 16.7346C5.08586 18.5552 9.57685 17.016 13.2962 13.2967Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 11.5002C10.8284 11.5002 11.5 10.8286 11.5 10.0002C11.5 9.17173 10.8284 8.50015 10 8.50015C9.17157 8.50015 8.5 9.17173 8.5 10.0002C8.5 10.8286 9.17157 11.5002 10 11.5002Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_554_3125">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
